import { Button, Card, CardSection, Text } from '@growtherapy/sprout-ui';

import {
  MINOR_ACKNOWLEDGEMENT_CANCEL_BUTTON_TEXT,
  MINOR_CONSENT_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT,
  MINOR_CONSENT_ACKNOWLEDGEMENT_TEXT,
  MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT,
  MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_TEXT,
} from './constants';

export function MinorTranscriptionAcknowledgement({
  hasConsent,
  onCancel,
  onConfirm,
}: {
  hasConsent: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Card className='w-[88vw] xs:max-w-[25rem] p-0 sm:p-0'>
      <CardSection className='p-6'>
        <Text variant='sm' className='text-neutral-800 text-left'>
          {hasConsent ? MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_TEXT : MINOR_CONSENT_ACKNOWLEDGEMENT_TEXT}
        </Text>
      </CardSection>
      <CardSection className='px-6 last:pb-6 flex justify-center'>
        <Button onClick={onCancel} use='secondary'>
          {MINOR_ACKNOWLEDGEMENT_CANCEL_BUTTON_TEXT}
        </Button>
        <Button onClick={onConfirm} use='primary'>
          {hasConsent
            ? MINOR_TRANSCRIPTION_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT
            : MINOR_CONSENT_ACKNOWLEDGEMENT_CONFIRM_BUTTON_TEXT}
        </Button>
      </CardSection>
    </Card>
  );
}
